import { Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultRadios } from "../../../../Constant";
import { DEFAULT_RADIO, DEFAULT_RADIO_LIST } from "../../../../Data/FormControl/CheckboxAndRadio";
import { H6 } from "../../../../AbstractElements";
import { CustomRadios } from "./CustomRadios";

const DefaultRadio = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={DefaultRadios} span={DEFAULT_RADIO} />
        <CardBody>
          <Row className="g-3">
            <CustomRadios />
            {DEFAULT_RADIO_LIST.map(({ title, span, className }, index) => (
              <Col sm="6" xl="4" key={index}>
                <div className="card-wrapper border rounded-3 checkbox-checked">
                  <H6 className="sub-title">{title}</H6>
                  {span.map(({ id, label, defaultChecked, disabled }, index) => (
                    <div className={`form-check ${className}`} key={index}>
                      <Input id={id} type="radio" name="flexRadioDefault" defaultChecked={defaultChecked} disabled={disabled} />
                      <Label htmlFor={id} check>
                        {label}
                      </Label>
                    </div>
                  ))}
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultRadio;
